import React, { Component } from 'react';
import { connect } from 'dva';
import router from 'umi/router';
import Container from '../../../../../../components/Container';
import { getAppCode, GetQueryString } from '../../../utils/utils';
import { Button, Form, Tabs, Spin, Icon, Upload, message, Modal, Tag } from 'antd';
import FormCreate from '../../../../../../components/FormCreate/index';
import SelectTagModal from '../../../components/SelectTag/index'
import styles from './index.less';

const {
  FormTitle,
  FormSelect,
  SelectUserVersion4,
  FormRadioGroup,
} = FormCreate;

@Form.create()

@connect(({ contentRecommend, user }) => ({
  ...contentRecommend,
  currentUser: user.currentUser,
}))

class Edit extends Component {
  constructor(props) {
    super(props);
    this.state = {
      labelModalVisible: false,
      checkedValue: [],
      groupData: []

    };
    this.id = GetQueryString('id');
  }

  componentWillUnmount() {
    const { dispatch } = this.props;
    dispatch({
      type: 'contentRecommend/reset',
    });
    this.setState({
      checkedValue: [],
      groupData: []
    })

  }


  componentDidMount() {
    const { dispatch } = this.props;
    dispatch({
      type: 'contentRecommend/fetchLabelWithGroup',
      params: { appCode: getAppCode() },
    }).then(res => {
      if (this.id) {
        dispatch({
          type: 'contentRecommend/fetchRuleById',
          params: { appCode: getAppCode(), ruleId: this.id },
        }).then(ruleDetails => {
          const { labelVOList } = ruleDetails;
          dispatch({
            type: 'contentRecommend/saveState',
            payload: {
              formData: ruleDetails,
            },
          });
          res.forEach(item => {
            item.list.forEach(tag => {
              labelVOList.forEach(checkedValue => {
                if (checkedValue.labelId === tag.labelId) {
                  tag.checked = true
                }
              })
            })
          })
          this.setState({
            checkedValue: labelVOList,
            groupData: res
          })
        })
      } else {
        this.setState({
          checkedValue: [],
          groupData: res
        })

      }
    })

  }

  componentWillUnmount() {
    this.reset()
  }

  reset = () => {
    const { dispatch } = this.props;
    dispatch({
      type: 'contentRecommend/reset',
    });
    this.setState({
      checkedValue: [],
      groupData: [],
      labelModalVisible: false,
    })
  }

  saveOrUpdate = () => {
    const { form, dispatch, formData } = this.props;
    const { validateFields, getFieldsValue } = form;
    const values = getFieldsValue();
    validateFields(err => {
      if (!err) {
        dispatch({
          type: 'contentRecommend/fetchSaveOrUpdate',
          params: {
            ...values,
            appCode: getAppCode(),
            id: this.id
          },
        }).then(() =>
          message.success(`${this.id ? '修改' : '添加'}成功`))
        router.goBack()
        this.reset()
        console.log('values', values)
      }
    });
  }

  renderFooter = () => {
    let footerParams = {
      states: !0,
      demFooter: (
        <>
          <Button type="default" onClick={() => router.goBack()}> 取消</Button>
          <Button type='primary' onClick={this.saveOrUpdate}>确定</Button>
        </>
      ),
    };
    return footerParams;
  };


  handleOk = data => {
    const { checkedValue, groupData } = data;
    this.setState({
      checkedValue,
      groupData
    })
  }

  render() {
    const { form, formData, currentUser } = this.props;
    const { getFieldsValue, getFieldDecorator, getFieldValue } = form;
    const { name = '', type = '1', selectId = '', isRemind = '1', remindMode = '0' } = formData;
    const { orgType } = currentUser || {};
    const { checkedValue, groupData } = this.state;

    const customerFormItemLayout = {
      labelCol: { span: 6 },
      wrapperCol: { span: 10 },
    };
    const nameProps = {
      form,
      value: name,
      label: '规则名称',
      keyName: 'name',
      maxLength: 10,
      suffix: `${(getFieldsValue().name && getFieldsValue().name.length) || name.length || 0}/10`,
    };

    const typeProps = {
      form,
      value: `${type}`,
      label: '规则类型',
      keyName: 'type',
      isRequired: true,
      optionData: [
        { value: '1', label: '按内容标签推荐' },
      ],
    };

    const selectUserProps = {
      form,
      value: selectId,
      appName: "宣传管理",
      appId: 47,
      orgType,
      label: "推荐对象",
      message: "请选择推荐对象",
      keyName: "selectId",
      isRequired: true,
      selectProps: {
        multiple: true,
        selectType: "user",
        unCheckableNodeType: ["ORG"],
        showTabList: orgType == 'school' ? ['dept', 'innerContacts', 'schoolContacts', 'tags'] : ['dept', 'innerContacts', 'group', 'tags'],
        dialogProps: {
          title: "选人组件",
        },
        selectSignature: selectId,
        isSaveSelectSignature: true,
        requestParams: {
          strictUser: true,
          tagTypeList: orgType == 'school' ? ['0', '1'] : ['0', '1', '2'],
          selectTypeList: ['user', 'dept', 'org', 'group', 'tags'],
        }
      }
    };

    const isRemindProps = {
      form,
      value: `${isRemind}`,
      label: '推荐文章时是否消息提醒',
      keyName: 'isRemind',
      isRequired: true,
      RadioGroupOptions: [
        { label: '是', value: '1' },
        { label: '否', value: '0' },
      ],
    };

    const remindModeProps = {
      form,
      value: `${remindMode}`,
      label: '提醒方式',
      keyName: 'remindMode',
      isRequired: true,
      optionData: [
        { value: '0', label: '新增文章提醒' },
      ],
      formItemProps: { extra: '说明：新增文章提醒为文章创建完成后，符合已创建的规则给该标签下的推荐对象进行消息提醒。' },
    };

    return (
      <Container breStates={!0} version={2} defaultPadding footerParams={this.renderFooter()}>
        <div className={styles.root}>
          {/* <Spin spinning={spinning}> */}

          <div className='tag-title'>
            新增规则
          </div>
          <FormCreate customerFormItemLayout={customerFormItemLayout}>
            <FormTitle {...nameProps} />
            <FormSelect {...typeProps} />
            <Form.Item label="文章标签" {...customerFormItemLayout}>
              {getFieldDecorator(`labelVOList`, {
                initialValue: checkedValue,
                valuePropName: 'checkedValue',
                trigger: 'handleOk',
                getValueFromEvent: ({ checkedValue = [] } = {}) => {
                  return checkedValue;
                },
                rules: [
                  {
                    required: true,
                    message: '请选择标签',
                  },
                ],
              })(<SelectTagModal
                checkedValue={checkedValue}
                groupData={groupData}
                handleOk={this.handleOk}
              />)}
            </Form.Item>
            <SelectUserVersion4 {...selectUserProps} />
            <FormRadioGroup {...isRemindProps} />
            {
              Number(getFieldValue('isRemind')) === 1 && <FormSelect {...remindModeProps} />
            }

          </FormCreate>

          {/* </Spin> */}
        </div>
      </Container>
    );
  }
}
export default Edit;
